import { type Href, useRouter } from 'expo-router';
import { useCallback } from 'react';
import { parseOriginHref } from '../utils/originHref';

/**
 * Back navigation for a screen reachable from several places. A stated,
 * validated in-app origin wins (a lead opened from the calendar returns to
 * that calendar day); otherwise plain history.
 */
export function useOriginBack(from: unknown): () => void {
  const router = useRouter();
  const originHref = parseOriginHref(from);

  return useCallback(() => {
    if (originHref) {
      router.replace(originHref as Href);
      return;
    }
    router.back();
  }, [router, originHref]);
}
